import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { GoSignOut } from 'react-icons/go';
import { Menu, Transition } from '@headlessui/react';
import { FaCaretDown, FaLock, FaUserAlt } from 'react-icons/fa';

import { useCreateModal } from 'partial/components/Modal';
import { useGetProfile } from 'core-modules/profile/hooks';
import { useChangePassword, useActiveAccount } from 'modules/auth/hooks';
import ChangePasswordModal from 'partial/components/modals/ChangePasswordModal';

import ThumbIcon from './ThumbIcon';

function HeaderProfile() {
  const [profile] = useGetProfile();
  const [activeAccount] = useActiveAccount();
  const logo = profile?.logo ? profile?.logo[0]?.url || profile?.logo : '';
  const [changePassword, isChangePasswordLoading] = useChangePassword();
  const modal = useCreateModal('CHANGE_PASSWORD', { isChangePasswordLoading });
  const handleChangePassword = () => {
    modal({
      // eslint-disable-next-line
      content: (onClose) => ({ isChangePasswordLoading: isLoadingProp }) => (
        <ChangePasswordModal
          submit={changePassword}
          isLoading={isLoadingProp}
          onClose={onClose}
        />
      ),
    });
  };
  return (
    <>
      <Menu as="div" className="relative">
        {({ open }) => (
          <>
            <div>
              <Menu.Button className="text-sm relative flex justify-between items-center space-x-2 bg-white rounded-xl shadow px-3 py-2">
                <div className="flex space-x-2 items-center mr-1">
                  <ThumbIcon
                    className="h-10 w-10 rounded-lg"
                    url={logo}
                    alt={
                      activeAccount?.role === 'biller'
                        ? profile?.biller_name
                        : profile?.company_name
                    }
                  />
                  <div>
                    <div className="text-left text-gray-800">
                      {activeAccount?.role === 'biller'
                        ? profile?.biller_name
                        : profile?.company_name}
                    </div>
                    <div className="text-left text-primary-800 font-light">
                      {profile?.email_address}
                    </div>
                  </div>
                </div>
                <span className="sr-only">Open user menu</span>
                <span className="text-xl text-primary-800">
                  <FaCaretDown />
                </span>
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
              show={open}
            >
              <Menu.Items className="origin-top-right absolute right-0 mt-4 w-full rounded-xl shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                <Menu.Item>
                  <div className="flex items-center opacity-40 hover:opacity-100">
                    <span className="text-base pl-4 pr-2 text-gray-900">
                      <FaUserAlt />
                    </span>
                    <Link
                      to="/my-profile"
                      className="block py-2 text-base font-normal text-left text-gray-900 w-full"
                    >
                      View Profile
                    </Link>
                  </div>
                </Menu.Item>
                <Menu.Item>
                  <div className="flex items-center opacity-40 hover:opacity-100">
                    <span className="text-base pl-4 pr-2 text-gray-900">
                      <FaLock />
                    </span>
                    <button
                      type="button"
                      onClick={handleChangePassword}
                      className="block py-2 text-base font-normal text-left text-gray-900 w-full"
                    >
                      Change Password
                    </button>
                  </div>
                </Menu.Item>
                <Menu.Item>
                  <div className="flex items-center opacity-40 hover:opacity-100">
                    <span className="text-base pl-4 pr-2 text-danger-500">
                      <GoSignOut />
                    </span>
                    <Link
                      to="/logout"
                      className="block py-2 text-base font-normal text-danger-500 w-full"
                    >
                      Logout
                    </Link>
                  </div>
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </>
        )}
      </Menu>
    </>
  );
}

HeaderProfile.propTypes = {};

export default HeaderProfile;
